export default ['production-summary', 'global-settings']